import type { IIncomingTrafficFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import type { ColumnByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/column-by-keys";
import type { SuggestedColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { processColumnsByKeys } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/utils/processColumnsByKeys";

import * as columnNames from "../../constants/column-names";

const COLUMNS_BY_KEYS: ColumnByKeys<IIncomingTrafficFilterDto> = {
    monthlyVisits: [columnNames.VISITS_FIELD, columnNames.MONTHLY_VISITS_CHANGE_MOM_FIELD],

    mobileWebVisitsShare: [
        columnNames.DESKTOP_VS_MOBILEWEB_VISITS_SHARE_FIELD,
        columnNames.MOBILEWEB_VISITS_FIELD,
        columnNames.MOBILEWEB_VISITS_CHANGE_MOM_FIELD,
    ],

    avgMonthlyVisits: [columnNames.AVG_MONTHLY_VISITS_FIELD],

    uniqueVisitors: [columnNames.UNIQUE_VISITORS_FIELD],

    totalPageViews: [columnNames.PAGEVIEWS_FIELD],
};

const processIncomingTrafficFilter = (
    trafficfilterDto: Partial<IIncomingTrafficFilterDto>,
): readonly SuggestedColumnName[] => {
    return processColumnsByKeys<IIncomingTrafficFilterDto>(trafficfilterDto, COLUMNS_BY_KEYS);
};

export default processIncomingTrafficFilter;
